module.exports = __webpack_public_path__ + "img/car_0007.789791cb.jpg";